import { cn } from 'lib/helpers/utility';

import DocText from '../DocText';
import { DOC_GAPS, DOC_TEXT } from '../lib/docStyles';

/**
 * @param {React.ReactNode} [notes] - Extra fine print under the footer line;
 *   the patient-facing invoice puts its GFE and billing-help notices there.
 */
const DocFooter = ({ closing, legal, page = 'Page 1 of 1', notes, className }) => (
  <div className={className}>
    {closing && (
      <DocText size="xs" className={cn(DOC_TEXT.closing, DOC_GAPS.closing)}>
        {closing}
      </DocText>
    )}
    <div
      className={cn(
        closing ? DOC_GAPS.footer : '',
        'border-0 border-t border-solid border-neutral-300'
      )}
    />
    <div className="mt-2 flex items-start justify-between gap-x-6">
      <DocText size="xs" className={DOC_TEXT.footer}>
        {legal}
      </DocText>
      {page && (
        <DocText size="xs" className={cn(DOC_TEXT.footerPage, 'w-auto whitespace-nowrap')}>
          {page}
        </DocText>
      )}
    </div>
    {notes && <div className="mt-1 flex flex-col gap-0.5">{notes}</div>}
  </div>
);

export default DocFooter;
